/**
 * Created by dx.yang on 2017/2/22.
 */

import uuid from '../../services/uuid';

export default {
    name: 'KsTableAdvColumn',
    props: {
        label: String,
        width: String,
        field: String,
        filter: null,
        sort: null,
        tips: null,
        tipmsg: String,
        visible: {
            type: Boolean,
            default: true
        },
        className: String
    },
    data() {
        return {
            uuid: null
        };
    },
    created() {
        this.uuid = uuid.create(4);
    },
    beforeDestroy() {
        // 删除列
        this.$parent.store.commit('removeColumn', this.uuid);
    },
    watch: {
        filter: {
            immediate: true,
            deep: true,
            handler(val) {
                if (!val || val.length === 0) {
                    return;
                }
                this.$parent.store.commit('setFilter', {
                    field: this.field,
                    filter: this.filter,
                })
            }    
        },
        visible: {
            immediate: true,
            deep: true,
            handler:function(val, old) {
                if(typeof(old) === 'undefined') return;
                this.$parent.store.commit('setVisible', {
                    visible: this.visible,
                    label: this.label
                })
            }
        }
    },
    mounted() {
        let idx = _.indexOf(this.$parent.$refs.columns.children, this.$el);
            // 增加列
        this.$parent.store.commit('insertColumn', {
            idx,
            uuid: this.uuid,
            sort: this.sort,
            tips: this.tips,
            tipmsg: this.tipmsg,
            label: this.label,
            width: this.width,
            realWidth: this.width,
            field: this.field,
            filter: this.filter,
            show: false,
            template: this.$scopedSlots.default,
            visible: this.visible,
            className: this.className
        });
    }
};